import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-form-input-exp',
  styleUrls: ['form-inputExp.component.scss'],
  template: `
    @if (props.label) {
      <label
        for="input-exp-{{ field.key }}"
        class="section col-12"
        tabindex="0"
        [innerHTML]="props.label"
      ></label>
    }
    @if (props.prompt) {
      <p class="explanation" tabindex="0" [innerHTML]="props.prompt"></p>
    }
    <mat-form-field floatPlaceholder="auto" class="w-100">
      <mat-label>{{ to.placeholder }}</mat-label>
      <input
        id="input-exp-{{ field.key }}"
        type="{{ to.number === true ? 'number' : '' }}"
        min="{{ to.min }}"
        max="{{ to.max }}"
        attr.maxlength="{{ to.maxLength ? to.maxLength : '' }}"
        matInput
        [placeholder]="props.placeholder || props.label"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [required]="props.required"
        (change)="props.change ? to.change(field, formControl) : ''"
        (blur)="replaceChar($event)"
        (keypress)="
          props.number && ($event.charCode < 48 || $event.charCode > 57)
            ? $event.preventDefault()
            : null
        "
      />
      @if (props.help) {
        <span
          matTooltip="{{ props.help }}"
          aria-label="help"
          tabindex="0"
          [matTooltipPosition]="'above'"
          [matTooltipClass]="'rb-tooltip'"
        >
          <mat-icon class="col-1 help-icon"> help </mat-icon>
        </span>
      }
      @if (
        formControl.hasError('required') && !formControl.hasError('regRequired')
      ) {
        <mat-error>This field is required</mat-error>
      }
      @if (formControl.hasError('regRequired')) {
        <mat-error>
          This field is needed for suitability review. You can opt out below if
          the applicant refuses to provide the information.
        </mat-error>
      }
    </mat-form-field>
  `,
  imports: [
    FormlyModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
})
export class FormlyCustomInputExpComponent extends FieldType {
  replaceChar(ev): void {
    if (
      this.formControl.value?.includes('|') &&
      this.field.props.context?.type !== 'unitProfile'
    ) {
      this.formControl.setValue(this.formControl.value.replaceAll('|', '¦'));
    }
  }
}
